import { useMemo } from 'react';
import { AlexaVisibilityResult } from '@blisspointmedia/bpm-types/dist/AlexaVisibility';
import { buildBrandColorResolver } from '../alexa-visibility-colors';
import { rankCompetitorBrands } from '../alexa-visibility-utils';

const NO_EXTRA_BRANDS: string[] = [];

/**
 * Brand -> color for every chart on the page. Competitors are colored in order of how often Alexa
 * mentions them; `extraBrands` (brands a tab knows about that Alexa never listed as mentioned) are
 * dealt the colors after those, so a brand's color doesn't depend on which tab you are on.
 */
export const useBrandColor = (
  results: AlexaVisibilityResult[],
  targetBrand: string,
  extraBrands: string[] = NO_EXTRA_BRANDS
): ((brand: string | undefined) => string) =>
  useMemo(
    () =>
      buildBrandColorResolver(
        [...rankCompetitorBrands(results, targetBrand), ...extraBrands],
        targetBrand
      ),
    [results, targetBrand, extraBrands]
  );
